// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ls-0";